import { RegisterState } from './types';

export const DEFAULT_REGISTER_STATE: RegisterState = {
  step: 1,
};
